import * as R from "ramda";

export const getFullName = R.path(["use", "full_name"]);
export const getUse = R.prop("use");
